/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)
import moduleAnalytics from './analytics/moduleAnalytics.js'
import moduleBackend from './backend/moduleBackend.js'
import moduleNetwork from './network/moduleNetwork.js'
import moduleBilling from './billing/moduleBilling.js'
import moduleAuth from './auth/moduleAuth.js'
import moduleTunnels from './tunnels/moduleTunnels.js'
import moduleAttacks from './attacks/moduleAttack.js'

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    analytics: moduleAnalytics,
    backend: moduleBackend,
    network: moduleNetwork,
    billing: moduleBilling,
    auth: moduleAuth,
    tunnels: moduleTunnels,
    attacks: moduleAttacks,
  },
  strict: process.env.NODE_ENV !== 'production'
})
